import { Component, HostListener, Input, ViewChild } from '@angular/core';

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Constants } from 'src/app/app.constants';

import {
  AuthService,
  CardService,
  LocationService,
  MerchantService,
} from '../../../services/index';
import {
  Location,
  StampCard,
  Shapes,
  CardType,
  EarningMethod,
  CardVariant,
} from '../../../models/index';
import { AutomationsDialogComponent } from '../../engagement/automations_dialog/automations_dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { Options } from '@angular-slider/ngx-slider';
import { RewardDialogComponent } from '../reward-dialog/reward-dialog.component';
import { EarningMethodDialogComponent } from '../earning-method-dialog/earning-method-dialog.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { IconDialogComponent } from '../icon-dialog/icon-dialog.component';
import { GradientDialogComponent } from '../gradient-dialog/gradient-dialog.component';
import {
  BreakpointObserver,
  BreakpointState,
  Breakpoints,
} from '@angular/cdk/layout';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { AnalyticsAbstract } from 'src/app/services/analytics/analytics.abstract';
import { StorageService } from 'src/app/services/storage.service';
import { SendAs } from 'src/app/models/message';
import { Merchant } from 'src/app/models/merchant';
import { File } from 'src/app/models/file';
import { TwoOptionAlertComponent } from 'src/app/shared/components/two-option-alert/two-option-alert.component';
import { TextEditorComponent } from 'src/app/shared/components/text-editor/text-editor.component';
import { CreateVariantDialogComponent } from '../create-variant-dialog/create-variant-dialog.component';

@Component({
  selector: 'card-detail',
  templateUrl: './card-detail.component.html',
  styleUrls: ['./card-detail.component.css'],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ background: 'red' }),
        animate('1s ease-out', style({})),
      ]),
    ]),
  ],
})
export class CardDetailComponent {
  private readonly DEFAULT_VARIANT_PRIORITY = 0;
  private readonly MAX_VARIANT_NAME_LENGTH = 50;

  options = [
    {
      value: this.constants.assets.tag,
      label: 'NFC Tags only',
    },
    {
      value: this.constants.assets.card,
      label: 'NFC Cards only',
    },
    {
      value: this.constants.assets.both,
      label: 'NFC Tags & Cards',
    },
  ];
  selectedDailyOption: string = this.constants.assets.both;
  selectedIntervalOption: string = this.constants.assets.both;

  @Input() smallTitle = false;
  @Input() title = '';
  @Input() subtitle: string = '';

  @ViewChild('termsEditor') termsEditor?: TextEditorComponent;

  tabs = ['overview', 'theme', 'stamps', 'rewards', 'terms', 'more'];
  selectedTab = 'overview';
  selectedIndex = 0;

  interval: boolean = false;
  stampsPerDay: boolean = false;
  connectOverride: boolean = true;

  showLogo: boolean = true;
  showStamps: boolean = false;
  soundOn: boolean = true;
  stampIcon?: { mobile: string; web: string; filled: boolean } = {
    mobile: '0xf3e0',
    web: 'star',
    filled: false,
  };
  rewardIcon?: { mobile: string; web: string; filled: boolean } = {
    mobile: '0xf00e6',
    web: 'redeem',
    filled: false,
  };
  postAcquisitionIcon?: { mobile: string; web: string; filled: boolean } = {
    mobile: '0xe88e',
    web: 'celebration',
    filled: false,
  };

  rewardIcons?: {
    stamp?: number;
    mobile?: string;
    web?: string;
    filled?: boolean;
    image?: any;
  }[] = [];

  earningMethods: EarningMethod[] = [];

  stampImage?: { name: string; content: ArrayBuffer };
  rewardImage?: { name: string; content: ArrayBuffer };
  backgroundImage?: { name: string; content: ArrayBuffer };
  fromOptions: SendAs[] = [];
  cardGradient?:
    | {
        from: string;
        to: string;
        angle: number;
        value: number;
      }
    | null
    | undefined;

  colorOptions = ['Solid', 'Gradient'];

  submitted = false;

  totalInitialStamps = 12;

  totalStampsOptions: any = [];
  joinStampsOptions: any = [];
  stampsPerScanOptions: any = [];
  cardTypeOptions: { label: string; value: string; info: string }[] = [
    {
      label: 'Stamps',
      value: 'stamp',
      info: 'Customer gets rewards after obtaining a certain number of stamps',
    },
    {
      label: 'Points (fixed)',
      value: 'point',
      info: 'Customer gets rewards after obtaining a certain number of points',
    },
    {
      label: 'Points (open ended)',
      value: 'openEndedPoint',
      info: 'Customer accumulates points, which can be converted into rewards at any time',
    },
  ];

  pointsBasisOptions: any[] = [
    {
      name: 'Transaction',
      value: 'transaction',
      info: 'Customer earns a fixed number of points for each transaction',
      icon: '../../assets/fixed.png',
    },
    {
      name: 'Value',
      value: 'value',
      info: 'Customer earn points based on the value of the transaction',
      icon: '../../assets/incremental.png',
    },
  ];

  pointsEarningMethodOptions: any[] = [
    {
      name: 'Fixed Value',
      value: 'fixed',
      info: 'E.g. spend £10 or more to get 10 points',
      icon: '../../assets/fixed.png',
    },
    {
      name: 'Incremental',
      value: 'incremental',
      info: 'E.g. earn 1 point for every £1 spent',
      icon: '../../assets/incremental.png',
    },
  ];

  postAcquisitionActionTypeOptions: any[] = [];

  opacitySliderValue: number = 10;
  opacitySliderOptions: Options = {
    floor: 1,
    ceil: 10,
    disabled: false,
  };

  bgImageOpacityValue: number = 10;
  bgImageOpacityOptions: Options = {
    floor: 1,
    ceil: 10,
    disabled: false,
  };

  tags: { name: string }[] = [];
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  form!: FormGroup;
  titleFormControl: FormControl = new FormControl();
  descriptionFormControl: FormControl = new FormControl();
  fromFormControl: FormControl = new FormControl();
  locationFormControl: FormControl = new FormControl();
  cardColorFormControl: FormControl = new FormControl();
  textColorFormControl: FormControl = new FormControl();
  stampColorFormControl: FormControl = new FormControl();
  stampFillColorFormControl: FormControl = new FormControl();
  stampFillEmptyFormControl: FormControl = new FormControl();
  iconColorFormControl: FormControl = new FormControl();
  totalStampsFormControl: FormControl = new FormControl();
  joinStampsFormControl: FormControl = new FormControl();
  stampsPerScanStampsFormControl: FormControl = new FormControl();
  stampsPerDayStampsFormControl: FormControl = new FormControl();
  intervalHoursFormControl: FormControl = new FormControl();
  intervalMinutesFormControl: FormControl = new FormControl();
  cardTypeFormControl: FormControl = new FormControl();
  html = '';

  pointsBasisFormControl: FormControl = new FormControl();
  pointsEarningMethodFormControl: FormControl = new FormControl();
  valueFormControl: FormControl = new FormControl();
  totalPointsFormControl: FormControl = new FormControl();
  maxPointsFormControl: FormControl = new FormControl();
  joinPointsFormControl: FormControl = new FormControl();
  pointsPerScanFormControl: FormControl = new FormControl();
  pointsExpiryFormControl: FormControl = new FormControl();
  progressBarFormControl: FormControl = new FormControl();
  progressBarBgFormControl: FormControl = new FormControl();

  postAcquisitionEnabledFormControl: FormControl = new FormControl();
  postAcquisitionTitleFormControl: FormControl = new FormControl();
  postAcquisitionDescriptionFormControl: FormControl = new FormControl();
  postAcquisitionActionTitleFormControl: FormControl = new FormControl();
  postAcquisitionActionTypeFormControl: FormControl = new FormControl();
  postAcquisitionActionUrlFormControl: FormControl = new FormControl();

  saving = false;
  private savedStateSnapshot = '';
  private unsavedTrackingReady = false;
  private skipUnsavedChangesWarning = false;
  private lastCanDeactivatePromptAt = 0;
  private lastCanDeactivateResult = false;
  private readonly CAN_DEACTIVATE_PROMPT_DEDUPE_MS = 3000;

  editMode: boolean = false;
  cardLoading: boolean = false;
  locationsLoading: boolean = false;
  planLimitsLoading: boolean = false;
  error: boolean = false;
  card: StampCard = {};
  variants: CardVariant[] = [];
  readonly DEFAULT_THEME_OPTION = 'default';
  readonly NEW_VARIANT_OPTION = '__new_variant__';
  selectedThemeVariant = this.DEFAULT_THEME_OPTION;
  themeVariantFormControl: FormControl = new FormControl();
  themeVariantOptions: { label: string; value: string }[] = [];
  defaultThemeState: any;
  rewards: any[] = [];
  locations: Location[] = [];

  shape: Shapes = Shapes.square;

  selectedShapeBorderColor = '#344734';
  merchantLogo?: string | undefined;
  customLogo?: File | undefined;
  showCustomLogo = false;
  planLimits: any;

  showCustomBrandingOption = false;
  disabledLocations: boolean[] = [];

  pointsExpire = false;
  canEditCard = false;
  titlePlaceholder = 'e.g. Free coffee';
  descriptionPlaceholder = 'e.g. Buy 9 coffees, get your 10th free!';

  constructor(
    private breakpointObserver: BreakpointObserver,
    public constants: Constants,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private cardService: CardService,
    private authService: AuthService,
    private locationService: LocationService,
    private merchantService: MerchantService,
    private mixpanel: AnalyticsAbstract,
    private storageService: StorageService,
  ) {
    this.merchantLogo = this.authService.getMerchantLogo();

    this.route.params.subscribe((params) => (this.card.nanoid = params['id']));

    this.route.queryParams.subscribe((params) => {
      const tab = params['tab'];

      if (tab) {
        const index = this.tabs.findIndex((el) => el === tab);
        if (index >= 0) {
          this.selectedTab = tab;
          this.selectedIndex = index;
        }
      }
    });

    this.initializePostAcquisitionActionTypeOptions();

    if (this.card.nanoid) {
      this.editMode = true;
    }

    this.titleFormControl = new FormControl(
      { value: '', disabled: false },
      Validators.required,
    );

    this.descriptionFormControl = new FormControl(
      { value: '', disabled: false },
      Validators.required,
    );

    this.fromFormControl = new FormControl(
      { value: '', disabled: false },
      Validators.required,
    );

    this.locationFormControl = new FormControl(
      { value: '', disabled: false },
      Validators.required,
    );

    this.cardColorFormControl = new FormControl({
      value: '#e7d1b5',
      disabled: false,
    });

    this.stampColorFormControl = new FormControl({
      value: '#e7d1b5',
      disabled: false,
    });

    this.stampFillColorFormControl = new FormControl({
      value: '#344734',
      disabled: false,
    });

    this.stampFillEmptyFormControl = new FormControl({
      value: '#f2f2f2',
      disabled: false,
    });

    this.iconColorFormControl = new FormControl({
      value: '#ffffff',
      disabled: false,
    });

    this.textColorFormControl = new FormControl({
      value: '#000000',
      disabled: false,
    });

    this.totalStampsFormControl = new FormControl({
      value: 12,
      disabled: false,
    });

    this.joinStampsFormControl = new FormControl({
      value: 0,
      disabled: false,
    });

    this.stampsPerScanStampsFormControl = new FormControl({
      value: 1,
      disabled: false,
    });

    this.stampsPerDayStampsFormControl = new FormControl({
      value: '',
      disabled: false,
    });

    this.intervalHoursFormControl = new FormControl({
      value: 0,
      disabled: false,
    });

    this.intervalMinutesFormControl = new FormControl({
      value: 30,
      disabled: false,
    });

    this.cardTypeFormControl = new FormControl(
      {
        value: '',
        disabled: false,
      },
      [Validators.required],
    );

    this.progressBarFormControl = new FormControl({
      value: '#344734',
      disabled: false,
    });

    this.progressBarBgFormControl = new FormControl({
      value: '#e4e8eb',
      disabled: false,
    });

    this.postAcquisitionEnabledFormControl = new FormControl({
      value: false,
      disabled: false,
    });

    this.postAcquisitionTitleFormControl = new FormControl({
      value: '',
      disabled: false,
    });

    this.postAcquisitionDescriptionFormControl = new FormControl({
      value: '',
      disabled: false,
    });

    this.postAcquisitionActionTitleFormControl = new FormControl({
      value: '',
      disabled: false,
    });

    this.postAcquisitionActionTypeFormControl = new FormControl({
      value: this.postAcquisitionActionTypeOptions[0],
      disabled: false,
    });

    this.postAcquisitionActionUrlFormControl = new FormControl({
      value: '',
      disabled: false,
    });

    this.themeVariantFormControl = new FormControl({
      value: this.DEFAULT_THEME_OPTION,
      disabled: false,
    });

    this.form = this.fb.group({
      title: this.titleFormControl,
      description: this.descriptionFormControl,
      locations: this.locationFormControl,
      stampColor: this.stampColorFormControl,
      stampFillColor: this.stampFillColorFormControl,
      stampFillEmptyColor: this.stampFillColorFormControl,
      iconColor: this.iconColorFormControl,
      cardColor: this.cardColorFormControl,
      textColor: this.textColorFormControl,
      totalStamps: this.totalStampsFormControl,
      joinStamps: this.joinStampsFormControl,
      stampsPerScan: this.stampsPerScanStampsFormControl,
      stampsPerDay: this.stampsPerDayStampsFormControl,
      intervalHours: this.intervalHoursFormControl,
      intervalMinutes: this.intervalMinutesFormControl,
      progressBarColor: this.progressBarFormControl,
      progressBarBgColor: this.progressBarBgFormControl,
      totalPoints: this.totalPointsFormControl,
      pointsBasis: this.pointsBasisFormControl,
      joinPoints: this.joinPointsFormControl,
      pointsPerScan: this.pointsPerScanFormControl,
      value: this.valueFormControl,
      earningMethod: this.pointsEarningMethodFormControl,
      postAcquisitionTitle: this.postAcquisitionTitleFormControl,
      postAcquisitionDescription: this.postAcquisitionDescriptionFormControl,
      postAcquisitionActionTitle: this.postAcquisitionActionTitleFormControl,
    });

    this.cardColorFormControl.valueChanges.subscribe((value) => {
      if (value) {
        this.cardGradient = null;
      }
    });

    // Set validators for post-acquisition popup fields
    this.postAcquisitionEnabledFormControl.valueChanges.subscribe((enabled) => {
      if (enabled) {
        this.postAcquisitionTitleFormControl.setValidators([
          Validators.required,
        ]);
        this.postAcquisitionDescriptionFormControl.setValidators([
          Validators.required,
        ]);
        this.postAcquisitionActionTitleFormControl.setValidators([
          Validators.required,
        ]);
      } else {
        this.postAcquisitionTitleFormControl.clearValidators();
        this.postAcquisitionDescriptionFormControl.clearValidators();
        this.postAcquisitionActionTitleFormControl.clearValidators();
      }
      this.postAcquisitionTitleFormControl.updateValueAndValidity();
      this.postAcquisitionDescriptionFormControl.updateValueAndValidity();
      this.postAcquisitionActionTitleFormControl.updateValueAndValidity();
    });

    // Set validators for URL field when action type is URL
    this.postAcquisitionActionTypeFormControl.valueChanges.subscribe(
      (actionType) => {
        if (actionType?.value === 'url') {
          this.postAcquisitionActionUrlFormControl.setValidators([
            Validators.required,
          ]);
        } else {
          this.postAcquisitionActionUrlFormControl.clearValidators();
        }
        this.postAcquisitionActionUrlFormControl.updateValueAndValidity();
      },
    );
  }

  ngOnInit() {
    this.subtitle = this.authService.getNestedUserProperty('merchant', 'name');
    this.setDynamicPlaceholders();

    if (!this.editMode) {
      this.getPlanLimits();
      this.getLocations();

      if (typeof this.authService.getUserProperty('merchant') != 'string') {
        const merchant = this.authService.getUserProperty(
          'merchant',
        ) as Merchant;
        if (merchant) {
          this.setCustomBrandingOption(merchant);
        }
      }
    } else {
      this.getCard();
    }

    this.totalStampsOptions = Array.from(
      { length: this.totalInitialStamps },
      (_, i) => i + 1,
    );

    this.updateStampOptions(this.totalInitialStamps);
    this.refreshThemeVariantOptions();
    this.defaultThemeState = this.captureThemeStateFromEditor();
    this.themeVariantFormControl.setValue(
      this.getThemeOptionByValue(this.DEFAULT_THEME_OPTION),
    );
    this.maybeInitializeUnsavedChangesTracking();
  }

  initializePostAcquisitionActionTypeOptions(): void {
    const hasVouchers =
      this.authService.getNestedUserProperty('merchant', 'vouchers') ?? false;

    this.postAcquisitionActionTypeOptions = [
      {
        label: 'Close popup',
        value: 'close',
        subtitle: 'This will only show one button that closes the popup',
      },
      {
        label: 'Open URL',
        value: 'url',
        subtitle: "This will open a URL on the customer's phone",
      },
    ];

    if (hasVouchers) {
      this.postAcquisitionActionTypeOptions.push({
        label: 'Navigate to Vouchers',
        value: 'vouchers',
        subtitle: 'This will navigate to the vouchers page in the app',
      });
    }
  }

  get canCreateCard(): boolean {
    if (this.editMode) {
      if (this.locations?.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      if (this.planLimits.cards > 0 && this.locations.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  }

  getPlanLimits(): void {
    this.planLimitsLoading = true;
    this.merchantService
      .getPlanLimits()
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.planLimits = res;
          }
        },
        error: (res: HttpErrorResponse) => {
          this.error = true;
          this.constants.snack(res.error.message);
        },
      })
      .add(() => {
        this.planLimitsLoading = false;
        this.maybeInitializeUnsavedChangesTracking();
      });
  }

  tabChanged(index: any): void {
    let tab = this.tabs[index];

    this.addQueryParams({ tab: tab });

    this.selectedTab = tab;

    this.mixpanel.track(Constants.analytics_keys.selectCardDetailTab, {
      Tab: tab,
    });
  }

  addQueryParams(params: any) {
    this.route.queryParams.subscribe((queryParams) => {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: params,
        queryParamsHandling: 'merge',
        skipLocationChange: false,
      });
    });
  }

  back() {
    this.router.navigate([Constants.routes.cards]);
  }

  cardTypeSelected(): void {
    this.setValidators();
  }

  pointsBasisSelected(): void {
    if (this.pointsBasisFormControl.value.value === 'value') {
      this.valueFormControl.setValidators([Validators.required]);
    } else {
      this.valueFormControl.clearValidators();
    }
  }

  setValidators(): void {
    if (this.cardTypeFormControl.value.value === CardType.point) {
      this.totalPointsFormControl.setValidators([Validators.required]);
      this.joinPointsFormControl.setValidators([Validators.required]);
      this.pointsPerScanFormControl.setValidators([Validators.required]);

      this.totalStampsFormControl.clearValidators();
      this.joinStampsFormControl.clearValidators();
      this.stampsPerScanStampsFormControl.clearValidators();
    } else if (
      this.cardTypeFormControl.value.value === CardType.openEndedPoint
    ) {
      this.joinPointsFormControl.setValidators([Validators.required]);
      this.pointsPerScanFormControl.setValidators([Validators.required]);

      this.totalStampsFormControl.clearValidators();
      this.joinStampsFormControl.clearValidators();
      this.stampsPerScanStampsFormControl.clearValidators();
    } else {
      this.totalStampsFormControl.setValidators([Validators.required]);
      this.joinStampsFormControl.setValidators([Validators.required]);
      this.stampsPerScanStampsFormControl.setValidators([Validators.required]);

      this.totalPointsFormControl.clearValidators();
      this.joinPointsFormControl.clearValidators();
      this.pointsPerScanFormControl.clearValidators();
    }

    this.totalStampsFormControl.updateValueAndValidity();
    this.joinStampsFormControl.updateValueAndValidity();
    this.stampsPerScanStampsFormControl.updateValueAndValidity();

    this.totalPointsFormControl.updateValueAndValidity();
    this.joinPointsFormControl.updateValueAndValidity();
    this.pointsPerScanFormControl.updateValueAndValidity();
  }

  updateStampOptions(length: number) {
    this.joinStampsOptions = Array.from({ length: length + 1 }, (_, i) => i);
    this.stampsPerScanOptions = Array.from({ length: length }, (_, i) => i + 1);

    if (length < this.joinStampsFormControl.value) {
      this.joinStampsFormControl.setValue(0);
    }

    if (length < this.stampsPerScanStampsFormControl.value) {
      this.stampsPerScanStampsFormControl.setValue(1);
    }

    this.rewards.forEach((reward) => {
      const stamp = reward.stamp;

      if (stamp > length) {
        reward.stamp = length;
      }
    });

    this.sortRewards();
  }

  sortRewards(): void {
    this.rewards = this.rewards.sort((a, b) => {
      if (this.isStampCard) {
        return a.stamp - b.stamp;
      } else {
        return a.points - b.points;
      }
    });
  }

  public isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result: BreakpointState) => {
        return result.matches;
      }),
    );

  getLocations(): void {
    this.locationsLoading = true;

    const subscription =
      this.authService.getUserProperty('userType') ===
      this.constants.userTypes.manager
        ? this.merchantService.getStaffLocations()
        : this.locationService.getLocations(1000, 0);

    subscription
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.locations = res?.docs ?? res;
            this.locations?.sort((a, b) => a.name!.localeCompare(b.name!));

            if (this.editMode) {
              this.locationFormControl.setValue(this.card.locations);

              for (var location of this.card.locations ?? []) {
                if (!this.locations.some((loc) => loc._id == location._id)) {
                  this.disabledLocations.push(true);
                }
              }
            } else {
              this.locationFormControl.setValue(this.locations);
            }

            const merchantName = this.authService.getNestedUserProperty(
              'merchant',
              'name',
            );

            if (merchantName) {
              this.fromOptions.push({
                name: merchantName,
                type: 'merchant',
              });
            }

            if (this.locations?.length) {
              this.locations.forEach((el: Location) => {
                this.fromOptions.push({
                  name: el.name!,
                  type: 'location',
                });
              });
            }

            if (this.card.displayAs) {
              this.fromFormControl.setValue(
                this.fromOptions.find(
                  (el) =>
                    el.name == this.card.displayAs?.name &&
                    el.type == this.card.displayAs?.type,
                ),
              );
            } else {
              this.fromFormControl.setValue(this.fromOptions[0]);
            }

            if (this.fromOptions?.length === 1) {
              this.fromFormControl.disable();
            }

            this.setCanEditCard();
          }
        },
        error: (res: HttpErrorResponse) => {
          this.error = true;
          this.constants.snack(res.error.message);
        },
      })
      .add(() => {
        this.locationsLoading = false;
        this.maybeInitializeUnsavedChangesTracking();
      });
  }

  getCard(): void {
    this.cardLoading = true;
    this.cardService
      .getCard(this.card.nanoid!)
      .subscribe({
        next: (res: StampCard) => {
          if (res) {
            this.card = res;
            this.titleFormControl.setValue(res.title);
            this.descriptionFormControl.setValue(res.description);
            this.html = res?.terms ?? '';
            this.totalStampsFormControl.setValue(res.numberOfStamps ?? 9);
            this.joinStampsFormControl.setValue(res.joinStamps ?? 0);
            this.stampsPerScanStampsFormControl.setValue(
              res.stampsPerScan ?? 1,
            );
            this.cardColorFormControl.setValue(res.colors?.card);
            this.textColorFormControl.setValue(res.colors?.text);
            this.stampColorFormControl.setValue(res.colors?.stampOutline);
            this.stampFillColorFormControl.setValue(res.colors?.stampFill);
            this.stampFillEmptyFormControl.setValue(res.colors?.stampFillEmpty);
            this.iconColorFormControl.setValue(res.colors?.icons);
            this.opacitySliderValue = res.icons?.opacity!;
            this.bgImageOpacityValue = res.backgroundImageOpacity ?? 10;
            this.rewards = res.rewards ?? [];
            this.earningMethods = res.earningMethods ?? [];
            this.sortRewards();

            this.showLogo = res.showLogo ?? true;
            this.soundOn = res.soundOn ?? true;
            this.shape = this.getShapeFromString(res.shape);

            // this.initialBackgroundImage = this.card.bgImage?.url
            //   ? this.card?.bgImage?.url + '?' + new Date().getTime()
            //   : null;

            this.setDailyRestriction(res);
            this.setIntervalRestriction(res);

            this.updateStampOptions(this.totalStampsFormControl.value);

            this.cardGradient = res.colors?.cardGradient;

            if (res.icons?.reward) {
              this.rewardIcon = res.icons?.reward!;
            }

            if (res.icons?.stamp) {
              this.stampIcon = res.icons?.stamp!;
            }

            this.card.locations?.sort((a, b) => a.name!.localeCompare(b.name!));

            this.rewardIcons = this.card.rewardIcons;
            this.variants = this.prepareVariantsForEditing(res.variants ?? []);
            this.refreshThemeVariantOptions();
            this.defaultThemeState = this.captureThemeStateFromEditor();
            this.selectedThemeVariant = this.DEFAULT_THEME_OPTION;
            this.themeVariantFormControl.setValue(
              this.getThemeOptionByValue(this.DEFAULT_THEME_OPTION),
            );

            this.getLocations();

            if (typeof this.card?.merchant != 'string') {
              const merchant = this.card.merchant as Merchant;
              if (merchant) {
                this.setCustomBrandingOption(merchant);
              }
            }

            if (this.card.customLogo?.url) {
              this.merchantLogo = this.card?.customLogo?.url;
              this.customLogo = this.card?.customLogo;
              this.showCustomLogo = true;
            } else {
              this.showCustomLogo = false;
            }

            // Load post-acquisition popup configuration
            if (this.card.postAcquisitionPopup) {
              this.postAcquisitionEnabledFormControl.setValue(
                this.card.postAcquisitionPopup.enabled ?? false,
              );
              this.postAcquisitionTitleFormControl.setValue(
                this.card.postAcquisitionPopup.title ?? '',
              );
              this.postAcquisitionDescriptionFormControl.setValue(
                this.card.postAcquisitionPopup.description ?? '',
              );

              if (this.card.postAcquisitionPopup.icon) {
                this.postAcquisitionIcon = this.card.postAcquisitionPopup.icon;
              }

              if (this.card.postAcquisitionPopup.actionButton) {
                this.postAcquisitionActionTitleFormControl.setValue(
                  this.card.postAcquisitionPopup.actionButton.title ?? '',
                );

                const actionType = this.postAcquisitionActionTypeOptions.find(
                  (el) =>
                    el.value ===
                    this.card.postAcquisitionPopup?.actionButton?.actionType,
                );
                this.postAcquisitionActionTypeFormControl.setValue(
                  actionType ?? this.postAcquisitionActionTypeOptions[0],
                );

                this.postAcquisitionActionUrlFormControl.setValue(
                  this.card.postAcquisitionPopup.actionButton.url ?? '',
                );
              }
            }

            this.cardTypeFormControl.setValue(
              this.cardTypeOptions.find(
                (el) => el.value === (this.card.cardType ?? CardType.stamp),
              ),
            );

            if (
              this.card.cardType === CardType.point ||
              this.card.cardType === CardType.openEndedPoint
            ) {
              this.pointsExpire = this.card?.points?.expiry?.active ?? false;
              this.pointsExpiryFormControl.setValue(
                this.card?.points?.expiry?.days,
              );
            }

            if (this.card.cardType === CardType.point) {
              this.progressBarFormControl.setValue(
                this.card.colors?.progressBar,
              );
              this.progressBarBgFormControl.setValue(
                this.card.colors?.progressBarBg,
              );

              this.totalPointsFormControl.setValue(
                this.card?.points?.totalPoints,
              );
            }

            if (this.card.cardType !== CardType.stamp) {
              this.joinPointsFormControl.setValue(
                this.card?.points?.joinPoints,
              );
              this.pointsPerScanFormControl.setValue(
                this.card?.points?.pointsPerScan,
              );
            }

            if (this.card.cardType === CardType.openEndedPoint) {
              this.maxPointsFormControl.setValue(this.card?.points?.maxPoints);

              this.valueFormControl.setValue(this.card?.points?.value);

              this.pointsBasisFormControl.setValue(
                this.pointsBasisOptions.find(
                  (el) => el.value === this.card?.points?.basis,
                ) ?? this.pointsBasisOptions[0],
              );

              this.pointsEarningMethodFormControl.setValue(
                this.pointsEarningMethodOptions.find(
                  (el) => el.value === this.card?.points?.earningMethod,
                ) ?? this.pointsEarningMethodOptions[0],
              );
            }

            this.connectOverride =
              this.card?.restrictions?.connectOverride ?? true;

            this.setValidators();
          }
        },
        error: () => {
          this.router
            .navigate(['/' + Constants.routes.dashboard], {})
            .then(() => {
              window.location.reload();
            });
        },
      })
      .add(() => {
        this.cardLoading = false;
        this.maybeInitializeUnsavedChangesTracking();
      });
  }

  setDailyRestriction(res: any) {
    const dailyRestrictions = res.restrictions?.daily;
    this.stampsPerDay = dailyRestrictions?.enabled ?? false;
    this.stampsPerDayStampsFormControl.setValue(dailyRestrictions?.value || 1);
    this.selectedDailyOption =
      res.restrictions?.daily?.asset || this.constants.assets.tag;
  }

  setIntervalRestriction(res: any) {
    const intervalRestrictions = res.restrictions?.interval;
    this.interval = intervalRestrictions?.enabled ?? false;
    const hoursAndMinutes = this.splitIntoHoursAndMinutes(
      intervalRestrictions?.value ?? 0,
    );

    this.intervalHoursFormControl.setValue(hoursAndMinutes.hours ?? 0);
    this.intervalMinutesFormControl.setValue(hoursAndMinutes.minutes ?? 0);

    this.selectedIntervalOption =
      res.restrictions?.interval?.asset || this.constants.assets.tag;
  }

  splitIntoHoursAndMinutes(value: number) {
    const hours = Math.floor(value / 60);
    const minutes = value % 60;
    return { hours, minutes };
  }

  getShapeFromString(shapeString?: string): Shapes {
    return (Shapes as any)[shapeString ?? 'circle'] as Shapes;
  }

  openIconPickerDialog(reward = false, custom = false, item?: any): void {
    if (!this.canEditCard) {
      return;
    }

    let rewardIcon;
    let rewardImage;

    const existingIndex = this.rewardIcons?.findIndex(
      (el) => el.stamp === item?.stamp,
    );

    const customReward = this.rewardIcons?.find(
      (el) => el.stamp === item?.stamp,
    );

    if (customReward) {
      rewardIcon = customReward;
      rewardImage = customReward.image;
    } else {
      rewardIcon = this.rewardIcon;
      rewardImage = this.rewardImage ?? this.card.rewardImage;
    }

    const dialogRef = this.dialog.open(IconDialogComponent, {
      width: '600px',
      minHeight: '559.5px',
      autoFocus: false,
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        filled: reward ? rewardIcon?.filled : this.stampIcon?.filled,
        isStampIcon: reward === false,
        iconImage: reward
          ? (rewardImage?.content ?? rewardImage?.url)
          : (this.stampImage?.content ?? this.card.stampImage?.url),
        rewardIcon: rewardIcon?.web,
        stampIcon: this.stampIcon?.web,
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        if (reward) {
          if (custom) {
            let obj = {};

            if (data.iconImage) {
              obj = {
                stamp: item?.stamp,
                image: data.iconImage,
              };
            } else {
              obj = {
                stamp: item?.stamp,
                mobile: data.mobile,
                web: data.web,
                filled: data.filled,
                image: null,
              };
            }

            if (existingIndex != undefined && existingIndex >= 0) {
              this.rewardIcons![existingIndex] = obj;
            } else {
              this.rewardIcons?.push(obj);
            }
          } else {
            if (data.iconImage) {
              this.rewardImage = data.iconImage;
              this.rewardIcon = undefined;
            } else {
              this.rewardImage = undefined;
              this.card.rewardImage = null as any;
              this.rewardIcon = data;
            }
          }
        } else {
          if (data.iconImage) {
            this.stampImage = data.iconImage;
            this.stampIcon = undefined;
          } else {
            this.stampImage = undefined;
            this.card.stampImage = null as any;
            this.stampIcon = data;
          }
        }
      }
    });
  }

  openPostAcquisitionIconDialog(): void {
    if (!this.canEditCard) {
      return;
    }

    const dialogRef = this.dialog.open(IconDialogComponent, {
      width: '600px',
      minHeight: '559.5px',
      autoFocus: false,
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        filled: this.postAcquisitionIcon?.filled,
        isStampIcon: false,
        rewardIcon: this.postAcquisitionIcon?.web,
        stampIcon: this.postAcquisitionIcon?.web,
        disableImageUpload: true,
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data && !data.iconImage) {
        this.postAcquisitionIcon = data;
      }
    });
  }

  previewPostAcquisitionPopup(): void {
    const title =
      this.postAcquisitionTitleFormControl.value?.trim() || 'Welcome!';
    const description =
      this.postAcquisitionDescriptionFormControl.value?.trim() ||
      'Thank you for joining our loyalty programme.';
    const actionType = this.postAcquisitionActionTypeFormControl.value?.value;
    const buttonTitle =
      this.postAcquisitionActionTitleFormControl.value?.trim() || 'Continue';

    const dialogData: any = {
      title: title,
      body: description,
      icon: this.postAcquisitionIcon,
      hideCloseIcon: true,
    };

    if (actionType === 'close') {
      dialogData.buttonTwo = buttonTitle || 'Close';
    } else {
      dialogData.buttonOne = 'Close';
      dialogData.buttonTwo = buttonTitle || 'Close';
    }

    this.dialog.open(TwoOptionAlertComponent, {
      data: dialogData,
      scrollStrategy: new NoopScrollStrategy(),
      autoFocus: false,
      width: '350px',
      disableClose: true,
      panelClass: 'custom-dialog',
    });
  }

  postAcquisitionActionTypeSelected(event: any): void {
    if (event.value === 'vouchers' || event.value === 'close') {
      this.postAcquisitionActionUrlFormControl.setValue('');
    }
  }

  save(): void {
    this.submitted = true;

    if (this.form.invalid) {
      const invalidFields = [];
      for (const control in this.form.controls) {
        if (this.form.controls[control].invalid) {
          invalidFields.push(control);
        }
      }

      this.constants.snack('Please complete all required fields');
      return;
    }

    if (this.cardTypeFormControl.value.value === CardType.point) {
      if (
        this.joinPointsFormControl.value > this.totalPointsFormControl.value
      ) {
        this.constants.snack(
          'Join points cannot be greater than the total available points',
        );
        return;
      }

      if (
        this.pointsPerScanFormControl.value > this.totalPointsFormControl.value
      ) {
        this.constants.snack(
          'Points per scan cannot be greater than the total available points',
        );
        return;
      }
    }

    let locations = (this.locationFormControl.value as Location[])
      .filter((el) => el._id !== undefined && el._id !== null)
      .map((el) => el._id);

    if (!locations.length) {
      this.constants
        .callbackSnack('Please select at least one reward', true)
        .subscribe(() => {
          this.selectedIndex = this.tabs.findIndex((el) => el == 'rewards');
          this.selectedTab = 'rewards';
        });
      return;
    }

    if (!this.rewards.length) {
      this.constants
        .callbackSnack('Please select at least one reward', true)
        .subscribe(() => {
          this.selectedIndex = this.tabs.findIndex((el) => el == 'rewards');
          this.selectedTab = 'rewards';
        });
      return;
    }

    if (!this.validateVariants()) {
      this.selectedIndex = this.tabs.findIndex((el) => el === 'theme');
      this.selectedTab = 'theme';
      return;
    }

    if (
      this.stampsPerDay &&
      (this.stampsPerDayStampsFormControl.value < 1 ||
        this.stampsPerDayStampsFormControl.value > 100)
    ) {
      this.constants.snack(
        'Stamps per day value must be between 1 - 100',
        true,
      );
      return;
    }

    if (this.interval) {
      const intervalHours = this.intervalHoursFormControl.value;
      const intervalMinutes = this.intervalMinutesFormControl.value;
      const totalMinutes =
        (this.intervalHoursFormControl.value ?? 0) * 60 +
        (this.intervalMinutesFormControl.value ?? 0);

      if (totalMinutes === 0) {
        this.constants.snack('Interval must be greater than 0', true);
        return;
      }

      if (intervalHours < 0 || intervalHours > 24) {
        this.constants.snack('Interval hours must be between 0 - 24', true);
        return;
      }

      if (intervalMinutes < 0 || intervalMinutes > 60) {
        this.constants.snack('Interval minutes must be between 0 - 60', true);
        return;
      }

      if (totalMinutes > 1440) {
        this.constants.snack(
          'Total interval cannot exceed 24 hours (1,440 minutes)',
          true,
        );
        return;
      }
    }

    // if (this.cardColorFormControl?.value && this.getContrastScore() < 4) {
    //   this.dialog.open(TwoOptionAlertComponent, {
    //     data: {
    //       title: 'Colour Contrast',
    //       body: 'Oops, it looks like the text colour and card surface contrast is too low, making it hard to read. Consider choosing a combination with better visibility for an optimal customer experience.',
    //       buttonTwo: 'OK',
    //     },
    //     autoFocus: false,
    //     width: '400px',
    //     // disableClose: true,
    //     panelClass: 'custom-dialog',
    //   });
    //   return;
    // }

    let intervalMinutes =
      (this.intervalHoursFormControl.value ?? 0) * 60 +
      (this.intervalMinutesFormControl.value ?? 0);

    this.persistCurrentThemeSelection();
    const defaultTheme =
      this.selectedThemeVariant === this.DEFAULT_THEME_OPTION
        ? this.captureThemeStateFromEditor()
        : this.defaultThemeState;
    const hasDefaultThemeGradient = Object.prototype.hasOwnProperty.call(
      defaultTheme?.colors ?? {},
      'cardGradient',
    );
    const hasDefaultThemeBackgroundImage = Object.prototype.hasOwnProperty.call(
      defaultTheme ?? {},
      'backgroundImage',
    );

    const payload = {
      title: this.titleFormControl.value?.trim(),
      description: this.descriptionFormControl.value?.trim(),
      terms:
        this.termsEditor?.getSanitizedAndLinkifiedContent() || this.html.trim(),
      numberOfStamps: this.totalStampsFormControl.value,
      joinStamps: this.joinStampsFormControl.value,
      stampsPerScan: this.stampsPerScanStampsFormControl.value,
      active: true,
      colors: {
        card: defaultTheme?.colors?.card ?? this.cardColorFormControl.value,
        text: defaultTheme?.colors?.text ?? this.textColorFormControl.value,
        stampOutline:
          defaultTheme?.colors?.stampOutline ??
          this.stampColorFormControl.value,
        stampFill:
          defaultTheme?.colors?.stampFill ??
          this.stampFillColorFormControl.value,
        stampFillEmpty:
          defaultTheme?.colors?.stampFillEmpty ??
          this.stampFillEmptyFormControl.value,
        icons: defaultTheme?.colors?.icons ?? this.iconColorFormControl.value,
        cardGradient: hasDefaultThemeGradient
          ? defaultTheme?.colors?.cardGradient
          : this.cardGradient,
        progressBar:
          defaultTheme?.colors?.progressBar ??
          this.progressBarFormControl.value,
        progressBarBg:
          defaultTheme?.colors?.progressBarBg ??
          this.progressBarBgFormControl.value,
      },
      icons: {
        opacity: defaultTheme?.icons?.opacity ?? this.opacitySliderValue,
        stamp: defaultTheme?.icons?.stamp ?? this.stampIcon ?? null,
        reward: defaultTheme?.icons?.reward ?? this.rewardIcon ?? null,
      },
      rewards: this.rewards.map((el) => ({
        stamp: el?.stamp,
        reward: el.reward._id,
        points: el?.points,
      })),
      earningMethods: this.earningMethods,
      points: {
        totalPoints: this.totalPointsFormControl.value,
        joinPoints: this.joinPointsFormControl.value,
        maxPoints: this.maxPointsFormControl.value,
        pointsPerScan: this.pointsPerScanFormControl.value,
        expiry: {
          active: this.pointsExpire,
          days: this.pointsExpiryFormControl.value,
        },
        basis: this.pointsBasisFormControl.value?.value,
        earningMethod:
          this.pointsBasisFormControl.value?.value === 'transaction'
            ? undefined
            : this.pointsEarningMethodFormControl.value?.value,
        value:
          this.pointsBasisFormControl.value?.value === 'transaction'
            ? undefined
            : this.valueFormControl.value,
      },
      id: this.card._id,
      locations: locations,
      showLogo: defaultTheme?.showLogo ?? this.showLogo,
      soundOn: this.soundOn,
      shape: (defaultTheme?.shape ?? this.shape).toString(),
      stampImage:
        defaultTheme?.stampImage ?? this.stampImage ?? this.card.stampImage,
      rewardImage:
        defaultTheme?.rewardImage ?? this.rewardImage ?? this.card.rewardImage,
      backgroundImage:
        hasDefaultThemeBackgroundImage
          ? defaultTheme?.backgroundImage
          : this.backgroundImage ?? this.card.backgroundImage,
      backgroundImageOpacity:
        defaultTheme?.backgroundImageOpacity ?? this.bgImageOpacityValue,
      restrictions: {
        connectOverride: this.connectOverride,
        daily: {
          enabled: this.stampsPerDay || false,
          value: this.stampsPerDayStampsFormControl.value || 1,
          asset: this.selectedDailyOption,
        },
        interval: {
          enabled: this.interval ?? false,
          value: intervalMinutes ?? 0,
          asset: this.selectedIntervalOption,
        },
      },
      displayAs: this.fromFormControl.value,
      customLogo: defaultTheme?.customLogo ?? {},
      showCustomLogo: defaultTheme?.showCustomLogo ?? this.showCustomLogo,
      rewardIcons: defaultTheme?.rewardIcons ?? this.rewardIcons,
      variants: this.variantsPayload,
      cardType: this.cardTypeFormControl?.value?.value,
      postAcquisitionPopup: this.postAcquisitionEnabledFormControl.value
        ? {
            enabled: true,
            icon: this.postAcquisitionIcon ?? null,
            title: this.postAcquisitionTitleFormControl.value?.trim(),
            description:
              this.postAcquisitionDescriptionFormControl.value?.trim(),
            actionButton: {
              enabled: true,
              title: this.postAcquisitionActionTitleFormControl.value?.trim(),
              actionType:
                this.postAcquisitionActionTypeFormControl.value?.value,
              url:
                this.postAcquisitionActionTypeFormControl.value?.value === 'url'
                  ? this.postAcquisitionActionUrlFormControl.value?.trim()
                  : undefined,
            },
          }
        : {
            enabled: false,
          },
    };

    const defaultCustomLogo = defaultTheme?.customLogo;
    const shouldShowDefaultCustomLogo =
      defaultTheme?.showCustomLogo ?? this.showCustomLogo;

    if (shouldShowDefaultCustomLogo && defaultCustomLogo) {
      payload.customLogo = defaultCustomLogo;
    }

    if (payload.stampImage) {
      payload.icons.stamp = null;
    }

    if (payload.rewardImage) {
      payload.icons.reward = null;
    }

    this.saving = true;

    if (this.editMode) {
      this.submit(this.cardService.editCard(payload), false);
    } else {
      this.submit(this.cardService.createCard(payload), true);
    }
  }

  submit(observable: Observable<any>, isNew: boolean): void {
    observable
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.skipUnsavedChangesWarning = true;
            this.router.navigate([Constants.routes.cards]).then(() => {
              if (isNew) {
                const existing = this.authService.getNestedUserProperty(
                  'merchant',
                  'onboard',
                );
                if (existing) {
                  this.authService.updateNestedProperty('merchant', 'onboard', {
                    location: existing.location ?? false,
                    reward: existing.reward ?? false,
                    card: true,
                  });
                  this.storageService.set('checklistVisible', String(true));
                }
                window.location.reload();
              }
            });
          }
        },
        error: (res: HttpErrorResponse) => {
          this.constants.snack(res.error.message);
        },
      })
      .add(() => (this.saving = false));
  }

  canDeactivate(): boolean {
    if (!this.shouldWarnUnsavedChanges()) {
      return true;
    }

    const now = Date.now();
    if (
      now - this.lastCanDeactivatePromptAt <
      this.CAN_DEACTIVATE_PROMPT_DEDUPE_MS
    ) {
      return this.lastCanDeactivateResult;
    }

    const confirmed = window.confirm(
      'You have unsaved changes. Are you sure you want to leave this page?',
    );
    this.lastCanDeactivatePromptAt = now;
    this.lastCanDeactivateResult = confirmed;

    if (confirmed) {
      // Prevent duplicate prompts during the same leave transition.
      this.skipUnsavedChangesWarning = true;
    }

    return confirmed;
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    if (!this.shouldWarnUnsavedChanges()) {
      return;
    }

    event.preventDefault();
    event.returnValue = '';
  }

  get tooltip(): string {
    if (this.loading) {
      return '';
    }
    if (!this.canCreateCard) {
      if (!this.locations?.length) {
        return this.constants.strings.addLocation;
      } else {
        return this.constants.strings.upgradePlanNotice;
      }
    } else {
      return '';
    }
  }

  totalPointsChanged(): void {
    this.rewards.forEach((reward: any) => {
      reward.points = this.totalPointsFormControl.value;
    });
  }

  maxPointsChanged(): void {
    // this.rewards.forEach((reward: any) => {
    //   reward.points = this.totalPointsFormControl.value;
    // });
  }

  openRewardDialog(): void {
    if (!this.canEditCard) {
      return;
    }

    const dialogRef = this.dialog.open(RewardDialogComponent, {
      data: {
        maxPoints: this.totalPointsFormControl.value,
        cardType: this.cardTypeFormControl?.value?.value,
        stampNumbers: Array.from(
          { length: this.totalStampsFormControl.value },
          (_, index) => index + 1,
        )
          .filter((el: number) => {
            return !this.rewards.some((ex: any) => ex?.stamp === el);
          })
          .map((el: number) => ({ number: el })),
      },
      scrollStrategy: new NoopScrollStrategy(),
      width: '450px',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        if (!this.isStampCard && data?.points === 0) {
          this.constants.snack('Points must be greater than 0');
        } else {
          this.rewards.push(data);
          this.sortRewards();
        }
      }
    });
  }

  removeReward(item: any): void {
    if (!this.canEditCard) {
      return;
    }

    const index = this.rewards.findIndex((el) => el === item);
    if (index !== -1) {
      this.rewards.splice(index, 1);
    }

    this.rewardIcons = this.rewardIcons?.filter(
      (el) => el.stamp !== item?.stamp,
    );

    this.sortRewards();
  }

  editReward(item: any): void {
    if (!this.canEditCard) {
      return;
    }

    const dialogRef = this.dialog.open(RewardDialogComponent, {
      data: {
        maxPoints: this.totalPointsFormControl.value,
        cardType: this.cardTypeFormControl?.value?.value,
        stampNumbers: Array.from(
          { length: this.totalStampsFormControl.value },
          (_, index) => index + 1,
        )
          .filter((el: number) => {
            return !this.rewards.some(
              (ex: any) => ex?.stamp === el && ex !== item,
            );
          })
          .map((el: number) => ({ number: el })),
        editMode: true,
        existingReward: item,
      },
      scrollStrategy: new NoopScrollStrategy(),
      width: '450px',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        if (!this.isStampCard && data?.points === 0) {
          this.constants.snack('Points must be greater than 0');
        } else {
          const index = this.rewards.findIndex((el) => el === item);
          if (index !== -1) {
            this.rewards[index] = data;
            this.sortRewards();
          }
        }
      }
    });
  }

  openEarningMethodDialog(): void {
    if (!this.canEditCard) {
      return;
    }

    const dialogRef = this.dialog.open(EarningMethodDialogComponent, {
      data: {
        cardType: this.cardTypeFormControl?.value?.value,
      },
      scrollStrategy: new NoopScrollStrategy(),
      width: '450px',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.earningMethods.push(data);
        this.sortEarningMethods();
      }
    });
  }

  sortEarningMethods(): void {
    this.earningMethods.sort(
      (a, b) => (a.pointsAwarded ?? 0) - (b.pointsAwarded ?? 0),
    );
  }

  removeEarningMethod(item: EarningMethod): void {
    if (!this.canEditCard) {
      return;
    }

    const index = this.earningMethods.findIndex((el) => el === item);
    if (index !== -1) {
      this.earningMethods.splice(index, 1);
    }
  }

  editEarningMethod(item: EarningMethod): void {
    if (!this.canEditCard) {
      return;
    }

    const dialogRef = this.dialog.open(EarningMethodDialogComponent, {
      data: {
        cardType: this.cardTypeFormControl?.value?.value,
        editMode: true,
        existingEarningMethod: item,
      },
      scrollStrategy: new NoopScrollStrategy(),
      width: '450px',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        const index = this.earningMethods.findIndex((el) => el === item);
        if (index !== -1) {
          this.earningMethods[index] = data;
        }
        this.sortEarningMethods();
      }
    });
  }

  get stampArray(): any[] {
    return Array.from(
      { length: this.totalStampsFormControl.value },
      (_, index) => index + 1,
    );
  }

  get loading(): boolean {
    return (
      this.locationsLoading ||
      this.cardLoading ||
      this.planLimitsLoading ||
      this.saving
    );
  }

  borderRadius(shape: Shapes): string {
    if (shape === Shapes.circle) {
      return '50%';
    }
    if (shape === Shapes.rounded) {
      return '15%';
    }

    return '0%';
  }

  get shapesEnum(): typeof Shapes {
    return Shapes;
  }

  getContrastScore(): number {
    const luminance1 = this.calculateLuminance(this.textColorFormControl.value);
    const luminance2 = this.calculateLuminance(this.cardColorFormControl.value);

    const contrastRatio =
      (Math.max(luminance1, luminance2) + 0.05) /
      (Math.min(luminance1, luminance2) + 0.05);

    // Map the contrast ratio to a scale from 1 to 10
    const contrastScore = Math.round(
      this.mapContrastRatioToScore(contrastRatio),
    );

    return contrastScore;
  }

  private calculateLuminance(hexColor: string): number {
    const rgb = this.hexToRgb(hexColor);
    return (
      0.2126 * this.adjustGamma(rgb.r / 255) +
      0.7152 * this.adjustGamma(rgb.g / 255) +
      0.0722 * this.adjustGamma(rgb.b / 255)
    );
  }

  private hexToRgb(hex: string): { r: number; g: number; b: number } {
    const bigint = parseInt(hex?.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return { r, g, b };
  }

  private adjustGamma(value: number): number {
    return value <= 0.03928
      ? value / 12.92
      : Math.pow((value + 0.055) / 1.055, 2.4);
  }

  private mapContrastRatioToScore(contrastRatio: number): number {
    return Math.min(Math.round(contrastRatio), 10);
  }

  hasLocations(): void {
    if (!this.locations.length) {
      this.constants.snack('Please add a location first');
    }
  }

  colorOptionPicked(option: any) {}

  deleteBackgroundImage(): void {
    this.backgroundImage = undefined;
    this.card.backgroundImage = undefined;
  }

  openGradientDialog(): void {
    const dialogRef = this.dialog.open(GradientDialogComponent, {
      width: '400px',
      autoFocus: false,
      disableClose: true,
      data: {
        cardGradient: this.cardGradient,
      },
      scrollStrategy: new NoopScrollStrategy(),
    });

    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.cardGradient = data;
        this.cardColorFormControl.setValue(null);
      }
    });
  }

  logEvent(event: any, trigger: any) {
    if (trigger === 'close' && event) {
      this.cardGradient = null;
    }
  }

  get restrictionTooltip(): string {
    if (this.isStampCard) {
      return `The total number of stamps a customer can receive on this card in a given day, resets at midnight.
    
            Applies to NFC only, the merchant can override this using the Portal or Remy Connect.`;
    } else {
      return `The total number of points a customer can receive on this card in a given day, resets at midnight.
    
            Applies to NFC only, the merchant can override this using the Portal or Remy Connect.`;
    }
  }

  get intervalRestrictionTooltip(): string {
    if (this.isStampCard) {
      return `The total time which must elapse between stamps, this can be used to reduce the risk that customers give themselves extra stamps when they shouldn't`;
    } else {
      return `The total time which must elapse between points, this can be used to reduce the risk that customers give themselves extra points when they shouldn't`;
    }
  }

  get connectOverrideTooltip(): string {
    return `Enable this to allow the restrictions set above to be overridden using the Remy Connect merchant app`;
  }

  get termsTooltip(): string {
    return `These are displayed in the customer's card wallet, you can use this to explain the terms of your card, for example, "Not valid with any other offer, or non-transferable"`;
  }

  get requiredStampsTooltip(): string {
    return `The required number of stamps for achieving the main reward on the customer's Stamp Card.
    
            For example, if the customer must buy 9 coffees to get their 10th free, you should choose 9 stamps which means the customer will get their reward on stamp number 9 which lets them have their 10th for free`;
  }

  get availablePointsTooltip(): string {
    return `The required number of points for achieving the main reward on the customer's Loyalty Card`;
  }

  get maxPointsTooltip(): string {
    return `The maximum number of points that can be achieved on the customer's Loyalty Card. Leave blank for no limit`;
  }

  get cardTypeTooltip(): string {
    return `Choose between a stamp card or a points card`;
  }

  get displayAsTooltip(): string {
    return `This is the name which will be displayed in the customer's card wallet.
    
            You can either leave this as your Merchant name, or set it to display the name of one of your locations - if you have set a custom logo for your location then this will also be used`;
  }

  get isStampCard(): boolean {
    return this.cardTypeFormControl.value?.value === CardType.stamp;
  }

  get isPointsCard(): boolean {
    return this.cardTypeFormControl.value?.value === CardType.point;
  }

  get isOpenEndedPointsCard(): boolean {
    return this.cardTypeFormControl.value?.value === CardType.openEndedPoint;
  }

  get hasSelectedCardType(): boolean {
    return this.cardTypeFormControl.value?.label !== undefined;
  }

  setCustomBrandingOption(merchant: Merchant) {
    if (merchant.customBranding) {
      this.showCustomBrandingOption = true;
    } else {
      this.showCustomBrandingOption = false;
    }
  }

  // getBorderRadius(inner = false): string {
  //   if (this.shape === Shapes.circle) {
  //     return '50%';
  //   }
  //   if (this.shape === Shapes.rounded) {
  //     if (inner) {
  //       return '11%';
  //     } else {
  //       return '15%';
  //     }
  //   }

  //   return '0%';
  // }

  // getIsFilled(index: number): boolean {
  //   return (
  //     (this.isReward(index)
  //       ? this.rewardIcon?.filled
  //       : this.stampIcon?.filled) ?? false
  //   );
  // }

  // isReward(index: number): boolean {
  //   for (const reward of this.rewards) {
  //     const i = index + 1;
  //     if (reward?.stamp?.number === i || reward?.stamp === i) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  // getIcon(index: number): string {
  //   return this.isReward(index) ? this.rewardIcon?.web! : this.stampIcon?.web!;
  // }

  displayAsSelected(displayAs: SendAs) {
    if (displayAs.type == 'location') {
      const location = this.locations.find((el) => el.name === displayAs.name);
      if (location && location?.logo?.url) {
        this.merchantLogo = location?.logo?.url;
        this.customLogo = location?.logo;
        this.showCustomLogo = true;
      }
    } else {
      this.merchantLogo = this.authService.getMerchantLogo();
      this.customLogo = undefined;
      this.showCustomLogo = false;
    }
  }

  removeStampFillColour(): void {
    this.stampFillColorFormControl.setValue(null);
  }

  // get stampPromoString(): string | null {
  //   const promo = this.card.stampPromo;

  //   if (!promo || !promo.end) {
  //     return null;
  //   }

  //   const endDate = new Date(promo.end!);
  //   const formattedDate = endDate.toLocaleString('en-GB', {
  //     day: '2-digit',
  //     month: '2-digit',
  //     year: '2-digit',
  //     hour: '2-digit',
  //     minute: '2-digit',
  //     hour12: false,
  //   });

  //   if (this.card.stampPromo?.active) {
  //     return `Reverts back to ${this.card.stampPromo.originalStamps} ${
  //       this.card.stampPromo.originalStamps === 1 ? ' stamp' : ' stamps'
  //     } on ${formattedDate}`;
  //   } else {
  //     return null;
  //   }
  // }

  customRewardIcon(reward: any) {
    let customReward = this.rewardIcons?.find(
      (el) => el.stamp === reward?.stamp,
    );

    if (customReward) {
      return customReward;
    }

    return this.rewardIcon;
  }

  customRewardImage(reward: any) {
    let customReward = this.rewardIcons?.find(
      (el) => el.stamp === reward?.stamp,
    );

    if (customReward && customReward?.web) {
      return null;
    }

    if (customReward && customReward?.image) {
      return customReward?.image?.content ?? customReward?.image?.url;
    }

    return this.rewardImage?.content ?? this.card?.rewardImage?.url;
  }

  get canSelectReward(): boolean {
    if (!this.isStampCard) {
      if (this.rewards?.length) {
        return true;
      } else {
        if (!this.isOpenEndedPointsCard) {
          if (!(this.totalPointsFormControl.value > 0)) {
            return false;
          }
          if (!(this.pointsPerScanFormControl.value > 0)) {
            return false;
          }
        }
      }

      return true;
    } else {
      return true;
    }
  }

  setCanEditCard() {
    this.canEditCard = (!this.editMode || this.card._canManage) ?? false;

    if (!this.canEditCard) {
      this.titleFormControl.disable();
      this.descriptionFormControl.disable();
      this.fromFormControl.disable();
      this.totalStampsFormControl.disable();
      this.totalPointsFormControl.disable();
      this.joinStampsFormControl.disable();
      this.joinPointsFormControl.disable();
      this.pointsPerScanFormControl.disable();
      this.stampsPerScanStampsFormControl.disable();
      this.pointsExpiryFormControl.disable();
      this.postAcquisitionEnabledFormControl.disable();
      this.postAcquisitionTitleFormControl.disable();
      this.postAcquisitionDescriptionFormControl.disable();
      this.postAcquisitionActionTitleFormControl.disable();
      this.postAcquisitionActionTypeFormControl.disable();
      this.postAcquisitionActionUrlFormControl.disable();
      this.themeVariantFormControl.disable();
    }
  }

  get selectedVariant(): CardVariant | undefined {
    if (this.selectedThemeVariant === this.DEFAULT_THEME_OPTION) {
      return undefined;
    }

    return this.findVariantByKey(this.selectedThemeVariant);
  }

  get canEditSelectedThemeVariant(): boolean {
    return this.canEditCard && !!this.selectedVariant;
  }

  get showVariantEditAction(): boolean {
    const selectedValue = this.themeVariantFormControl.value?.value;
    return (
      !!selectedValue &&
      selectedValue !== this.DEFAULT_THEME_OPTION &&
      selectedValue !== this.NEW_VARIANT_OPTION
    );
  }

  private getThemeOptionByValue(value: string): {
    label: string;
    value: string;
  } {
    return (
      this.themeVariantOptions.find((option) => option.value === value) ??
      this.themeVariantOptions[0]
    );
  }

  get variantsPayload(): CardVariant[] {
    return this.variants
      .map((variant) => {
        const domains = this.sanitizeEmailDomains(
          variant?.conditions?.emailDomains ?? [],
        );
        const emails = this.sanitizeEmails(variant?.conditions?.emails ?? []);
        const emailContains = this.sanitizeEmailContains(
          variant?.conditions?.emailContains ?? [],
        );

        return {
          ...variant,
          name: (variant.name ?? '').trim(),
          priority: Number(variant.priority ?? this.DEFAULT_VARIANT_PRIORITY),
          conditions: {
            ...(variant.conditions ?? {}),
            emailDomains: domains,
            emails: emails,
            emailContains: emailContains,
          },
        };
      })
      .filter((variant) => variant.name);
  }

  addVariant(config: {
    name: string;
    conditions: {
      emailDomains?: string[];
      emails?: string[];
      emailContains?: string[];
    };
    active?: boolean;
    priority?: number;
  }): void {
    if (!this.canEditCard) {
      return;
    }

    const variant: CardVariant = {
      name: config.name.trim(),
      active: config.active ?? true,
      priority: Number(config.priority ?? this.DEFAULT_VARIANT_PRIORITY),
      conditions: {
        emailDomains: this.sanitizeEmailDomains(
          config.conditions?.emailDomains ?? [],
        ),
        emails: this.sanitizeEmails(config.conditions?.emails ?? []),
        emailContains: this.sanitizeEmailContains(
          config.conditions?.emailContains ?? [],
        ),
      },
    };

    this.applyThemeStateToVariant(variant, this.defaultThemeState);
    this.variants.push(variant);
    this.refreshThemeVariantOptions();

    this.selectThemeVariant(
      this.getVariantKey(variant, this.variants.length - 1),
    );
  }

  async openNewVariantDialog(): Promise<void> {
    if (!this.canEditCard) {
      return;
    }

    const previousThemeKey = this.selectedThemeVariant;
    const restorePreviousSelection = () => {
      this.themeVariantFormControl.setValue(
        this.getThemeOptionByValue(previousThemeKey),
      );
    };

    const dialogRef = this.dialog.open(CreateVariantDialogComponent, {
      width: '560px',
      autoFocus: false,
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        title: 'Create Variant',
        actionTitle: 'Create',
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result?.changed) {
        restorePreviousSelection();
        return;
      }

      const name = result?.value?.name?.trim();
      const conditions = {
        emailDomains: this.sanitizeEmailDomains(
          result?.value?.conditions?.emailDomains ?? [],
        ),
        emails: this.sanitizeEmails(result?.value?.conditions?.emails ?? []),
        emailContains: this.sanitizeEmailContains(
          result?.value?.conditions?.emailContains ?? [],
        ),
      };
      const hasCondition =
        (conditions.emailDomains?.length ?? 0) > 0 ||
        (conditions.emails?.length ?? 0) > 0 ||
        (conditions.emailContains?.length ?? 0) > 0;

      if (!name || !hasCondition) {
        this.constants.snack('Please complete all variant fields');
        restorePreviousSelection();
        return;
      }

      this.addVariant({
        name: name,
        conditions: conditions,
        active: result?.value?.active ?? true,
        priority: Number(
          result?.value?.priority ?? this.DEFAULT_VARIANT_PRIORITY,
        ),
      });

      const createdVariant = this.variants[this.variants.length - 1];
      if (createdVariant) {
        createdVariant.active = result?.value?.active ?? true;
        createdVariant.priority = Number(
          result?.value?.priority ?? this.DEFAULT_VARIANT_PRIORITY,
        );
      }
    });
  }

  editSelectedVariantSettings(): void {
    if (!this.canEditSelectedThemeVariant || !this.selectedVariant) {
      return;
    }

    const selectedVariant = this.selectedVariant;
    const dialogRef = this.dialog.open(CreateVariantDialogComponent, {
      width: '560px',
      autoFocus: false,
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        title: 'Edit Variant',
        actionTitle: 'Save',
        showDelete: true,
        value: {
          name: selectedVariant.name,
          conditions: {
            emailDomains: selectedVariant.conditions?.emailDomains ?? [],
            emails: selectedVariant.conditions?.emails ?? [],
            emailContains: selectedVariant.conditions?.emailContains ?? [],
          },
          priority: selectedVariant.priority ?? this.DEFAULT_VARIANT_PRIORITY,
          active: selectedVariant.active ?? true,
        },
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.deleted) {
        const index = this.variants.findIndex(
          (variant) => variant === selectedVariant,
        );
        if (index >= 0) {
          this.variants.splice(index, 1);
          this.refreshThemeVariantOptions();
          this.selectedThemeVariant = this.DEFAULT_THEME_OPTION;
          this.themeVariantFormControl.setValue(
            this.getThemeOptionByValue(this.DEFAULT_THEME_OPTION),
          );
          this.applyThemeStateToEditor(this.defaultThemeState);
        }
        return;
      }

      if (!result?.changed || !selectedVariant) {
        return;
      }

      const name = result?.value?.name?.trim();
      const domains = this.sanitizeEmailDomains(
        result?.value?.conditions?.emailDomains ?? [],
      );
      const emails = this.sanitizeEmails(
        result?.value?.conditions?.emails ?? [],
      );
      const emailContains = this.sanitizeEmailContains(
        result?.value?.conditions?.emailContains ?? [],
      );
      const hasCondition =
        domains.length > 0 || emails.length > 0 || emailContains.length > 0;

      if (!name || !hasCondition) {
        this.constants.snack('Please complete all variant fields');
        return;
      }

      selectedVariant.name = name;
      selectedVariant.active = result?.value?.active ?? true;
      selectedVariant.priority = Number(
        result?.value?.priority ?? this.DEFAULT_VARIANT_PRIORITY,
      );
      selectedVariant.conditions = {
        ...(selectedVariant.conditions ?? {}),
        emailDomains: domains,
        emails: emails,
        emailContains: emailContains,
      };

      this.refreshThemeVariantOptions();
      this.themeVariantFormControl.setValue(
        this.getThemeOptionByValue(this.selectedThemeVariant),
      );
    });
  }

  themeVariantSelected(option: { label: string; value: string }): void {
    const value = option?.value;
    if (!value) {
      return;
    }

    if (value === this.NEW_VARIANT_OPTION) {
      this.openNewVariantDialog();
      return;
    }

    this.selectThemeVariant(value);
  }

  selectThemeVariant(nextKey: string): void {
    if (!nextKey || nextKey === this.selectedThemeVariant) {
      return;
    }

    this.persistCurrentThemeSelection();
    this.selectedThemeVariant = nextKey;
    this.themeVariantFormControl.setValue(this.getThemeOptionByValue(nextKey));

    if (nextKey === this.DEFAULT_THEME_OPTION) {
      this.applyThemeStateToEditor(this.defaultThemeState);
      return;
    }

    const variant = this.findVariantByKey(nextKey);
    if (!variant) {
      this.selectedThemeVariant = this.DEFAULT_THEME_OPTION;
      this.themeVariantFormControl.setValue(
        this.getThemeOptionByValue(this.DEFAULT_THEME_OPTION),
      );
      this.applyThemeStateToEditor(this.defaultThemeState);
      return;
    }

    const variantState = this.buildThemeStateForVariant(variant);
    this.applyThemeStateToEditor(variantState);
  }

  persistCurrentThemeSelection(): void {
    const currentState = this.captureThemeStateFromEditor();

    if (this.selectedThemeVariant === this.DEFAULT_THEME_OPTION) {
      this.defaultThemeState = currentState;
      return;
    }

    const variant = this.findVariantByKey(this.selectedThemeVariant);
    if (variant) {
      this.applyThemeStateToVariant(variant, currentState);
    }
  }

  sanitizeEmailDomains(domains: string[]): string[] {
    const unique = new Set<string>();

    for (const rawDomain of domains) {
      const normalizedDomain = this.normalizeEmailDomain(rawDomain);
      if (normalizedDomain) {
        unique.add(normalizedDomain);
      }
    }

    return Array.from(unique);
  }

  sanitizeEmails(emails: string[]): string[] {
    const unique = new Set<string>();

    for (const rawEmail of emails) {
      const normalizedEmail = this.normalizeEmail(rawEmail);
      if (normalizedEmail) {
        unique.add(normalizedEmail);
      }
    }

    return Array.from(unique);
  }

  sanitizeEmailContains(items: string[]): string[] {
    const unique = new Set<string>();

    for (const item of items) {
      const normalized = this.normalizeEmailContains(item);
      if (normalized) {
        unique.add(normalized);
      }
    }

    return Array.from(unique);
  }

  normalizeEmailDomain(rawDomain: string): string | null {
    if (!rawDomain || typeof rawDomain !== 'string') {
      return null;
    }

    let normalizedDomain = rawDomain.trim().toLowerCase().replace(/\s+/g, '');
    if (!normalizedDomain) {
      return null;
    }

    if (normalizedDomain.includes('@') && !normalizedDomain.startsWith('@')) {
      const splitDomain = normalizedDomain.split('@').pop();
      normalizedDomain = splitDomain ? `@${splitDomain}` : '';
    }

    if (!normalizedDomain.startsWith('@')) {
      normalizedDomain = `@${normalizedDomain}`;
    }

    if (!/^@[a-z0-9.-]+\.[a-z]{2,}$/i.test(normalizedDomain)) {
      return null;
    }

    return normalizedDomain;
  }

  normalizeEmail(rawEmail: string): string | null {
    if (!rawEmail || typeof rawEmail !== 'string') {
      return null;
    }

    const normalizedEmail = rawEmail.trim().toLowerCase().replace(/\s+/g, '');
    if (!normalizedEmail) {
      return null;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(normalizedEmail)) {
      return null;
    }

    return normalizedEmail;
  }

  normalizeEmailContains(rawValue: string): string | null {
    if (!rawValue || typeof rawValue !== 'string') {
      return null;
    }

    const normalized = rawValue.trim().toLowerCase();
    return normalized || null;
  }

  validateVariants(): boolean {
    const names = new Set<string>();

    for (const variant of this.variants) {
      const trimmedName = variant.name?.trim();
      if (!trimmedName) {
        this.constants.snack('Each variant requires a name');
        return false;
      }

      if (trimmedName.length > this.MAX_VARIANT_NAME_LENGTH) {
        this.constants.snack(
          `Variant name must be ${this.MAX_VARIANT_NAME_LENGTH} characters or fewer`,
        );
        return false;
      }

      const normalizedName = trimmedName.toLowerCase();
      if (names.has(normalizedName)) {
        this.constants.snack(`Duplicate variant name: "${trimmedName}"`);
        return false;
      }
      names.add(normalizedName);

      const domains = this.sanitizeEmailDomains(
        variant?.conditions?.emailDomains ?? [],
      );
      const emails = this.sanitizeEmails(variant?.conditions?.emails ?? []);
      const emailContains = this.sanitizeEmailContains(
        variant?.conditions?.emailContains ?? [],
      );
      const hasCondition =
        domains.length > 0 || emails.length > 0 || emailContains.length > 0;

      if (!hasCondition) {
        this.constants.snack(
          `Variant "${trimmedName}" needs at least one valid condition`,
        );
        return false;
      }

      variant.name = trimmedName;
      variant.conditions = {
        ...(variant.conditions ?? {}),
        emailDomains: domains,
        emails: emails,
        emailContains: emailContains,
      };
    }

    return true;
  }

  private prepareVariantsForEditing(variants: CardVariant[]): CardVariant[] {
    return variants.map((variant) => ({
      ...variant,
      active: variant.active ?? true,
      priority: Number(variant.priority ?? this.DEFAULT_VARIANT_PRIORITY),
      conditions: {
        ...(variant.conditions ?? {}),
        emailDomains: this.sanitizeEmailDomains(
          variant?.conditions?.emailDomains ?? [],
        ),
        emails: this.sanitizeEmails(variant?.conditions?.emails ?? []),
        emailContains: this.sanitizeEmailContains(
          variant?.conditions?.emailContains ?? [],
        ),
      },
    }));
  }

  private getVariantKey(variant: CardVariant, index: number): string {
    return variant._id ?? `variant-${index}`;
  }

  private refreshThemeVariantOptions(): void {
    this.themeVariantOptions = [
      { label: 'Default', value: this.DEFAULT_THEME_OPTION },
      ...this.variants.map((variant, index) => ({
        label: variant.name,
        value: this.getVariantKey(variant, index),
      })),
      { label: 'New Variant', value: this.NEW_VARIANT_OPTION },
    ];
  }

  private findVariantByKey(key: string): CardVariant | undefined {
    return this.variants.find(
      (variant, index) => this.getVariantKey(variant, index) === key,
    );
  }

  private captureThemeStateFromEditor(): any {
    return {
      colors: {
        card: this.cardColorFormControl.value,
        text: this.textColorFormControl.value,
        stampOutline: this.stampColorFormControl.value,
        stampFill: this.stampFillColorFormControl.value,
        stampFillEmpty: this.stampFillEmptyFormControl.value,
        icons: this.iconColorFormControl.value,
        cardGradient: this.cardGradient,
        progressBar: this.progressBarFormControl.value,
        progressBarBg: this.progressBarBgFormControl.value,
      },
      icons: {
        opacity: this.opacitySliderValue,
        stamp: this.stampIcon,
        reward: this.rewardIcon,
      },
      rewardIcons: this.rewardIcons ?? [],
      shape: this.shape?.toString(),
      showLogo: this.showLogo,
      customLogo: this.customLogo,
      showCustomLogo: this.showCustomLogo,
      stampImage: this.stampImage ?? this.card?.stampImage,
      rewardImage: this.rewardImage ?? this.card?.rewardImage,
      backgroundImage: this.backgroundImage ?? this.card?.backgroundImage,
      backgroundImageOpacity: this.bgImageOpacityValue,
    };
  }

  private applyThemeStateToEditor(state: any): void {
    if (!state) {
      return;
    }

    this.cardColorFormControl.setValue(state?.colors?.card);
    this.textColorFormControl.setValue(state?.colors?.text);
    this.stampColorFormControl.setValue(state?.colors?.stampOutline);
    this.stampFillColorFormControl.setValue(state?.colors?.stampFill);
    this.stampFillEmptyFormControl.setValue(state?.colors?.stampFillEmpty);
    this.iconColorFormControl.setValue(state?.colors?.icons);
    this.progressBarFormControl.setValue(state?.colors?.progressBar);
    this.progressBarBgFormControl.setValue(state?.colors?.progressBarBg);
    this.cardGradient = state?.colors?.cardGradient;

    this.opacitySliderValue = state?.icons?.opacity ?? this.opacitySliderValue;
    this.stampIcon = state?.icons?.stamp ?? this.stampIcon;
    this.rewardIcon = state?.icons?.reward ?? this.rewardIcon;
    this.rewardIcons = state?.rewardIcons ?? [];
    this.shape = this.getShapeFromString(state?.shape);
    this.showLogo = state?.showLogo ?? this.showLogo;

    const stampImage = state?.stampImage;
    this.stampImage = stampImage?.content ? stampImage : undefined;
    this.card.stampImage = stampImage?.content ? undefined : stampImage;

    const rewardImage = state?.rewardImage;
    this.rewardImage = rewardImage?.content ? rewardImage : undefined;
    this.card.rewardImage = rewardImage?.content ? undefined : rewardImage;

    const backgroundImage = state?.backgroundImage;
    this.backgroundImage = backgroundImage?.content
      ? backgroundImage
      : undefined;
    this.card.backgroundImage = backgroundImage?.content
      ? undefined
      : backgroundImage;

    this.bgImageOpacityValue =
      state?.backgroundImageOpacity ?? this.bgImageOpacityValue;

    this.customLogo = state?.customLogo;
    this.showCustomLogo = state?.showCustomLogo ?? this.showCustomLogo;

    if (this.showCustomLogo && this.customLogo?.url) {
      this.merchantLogo = this.customLogo.url;
    } else {
      this.merchantLogo = this.authService.getMerchantLogo();
    }
  }

  private applyThemeStateToVariant(variant: CardVariant, state: any): void {
    variant.colors = { ...(state?.colors ?? {}) };
    variant.icons = {
      opacity: state?.icons?.opacity ?? this.opacitySliderValue,
      stamp: state?.icons?.stamp,
      reward: state?.icons?.reward,
    };
    variant.rewardIcons = [...(state?.rewardIcons ?? [])];
    variant.shape = state?.shape;
    variant.showLogo = state?.showLogo;
    variant.customLogo = state?.customLogo;
    variant.stampImage = state?.stampImage;
    variant.rewardImage = state?.rewardImage;
    variant.backgroundImage = state?.backgroundImage;
    variant.backgroundImageOpacity = state?.backgroundImageOpacity;
  }

  private buildThemeStateForVariant(variant: CardVariant): any {
    const base = { ...(this.defaultThemeState ?? {}) };

    return {
      ...base,
      colors: {
        ...(base?.colors ?? {}),
        ...(variant?.colors ?? {}),
      },
      icons: {
        ...(base?.icons ?? {}),
        ...(variant?.icons ?? {}),
      },
      rewardIcons:
        variant?.rewardIcons !== undefined
          ? [...(variant?.rewardIcons ?? [])]
          : [...(base?.rewardIcons ?? [])],
      shape: variant?.shape ?? base?.shape,
      showLogo: variant?.showLogo ?? base?.showLogo,
      customLogo:
        variant?.customLogo !== undefined
          ? variant.customLogo
          : base?.customLogo,
      stampImage:
        variant?.stampImage !== undefined
          ? variant.stampImage
          : base?.stampImage,
      rewardImage:
        variant?.rewardImage !== undefined
          ? variant.rewardImage
          : base?.rewardImage,
      backgroundImage:
        variant?.backgroundImage !== undefined
          ? variant.backgroundImage
          : base?.backgroundImage,
      backgroundImageOpacity:
        variant?.backgroundImageOpacity ?? base?.backgroundImageOpacity,
    };
  }

  onColorInput(event: Event, formControl: FormControl): void {
    const input = event.target as HTMLInputElement;
    formControl.setValue(input.value);
  }

  openCampaigns(): void {
    this.dialog.open(AutomationsDialogComponent, {
      data: {},
      scrollStrategy: new NoopScrollStrategy(),
      autoFocus: false,
      width: '600px',
      disableClose: true,
      panelClass: 'custom-dialog',
    });
  }

  get spendInfo() {
    return `The amount the customer must spend in order to qualify for a the specified number of points`;
  }

  get valuePointsInfoFixed() {
    return `The number of points the customer should earn`;
  }

  get valuePointsInfoIncremental() {
    return `The number of points the customer should earn for every £x spent`;
  }

  get howToTitle(): string {
    return this.isStampCard ? 'How to give stamps' : 'How to give points';
  }

  get howToBody(): string {
    const giveViaNFC = `• Tap the customer's phone with your NFC card after they've opened their loyalty card`;
    const giveViaApp = `• Or, use the <a href="https://remyrewards.co.uk/mapp" target="_blank">Remy Connect</a> app to award a custom number of points.`;

    const eposNote = `<br><br><i>Using an EPOS system? Check out our <b>EPOS integrations</b> to award points automatically based on spend.</i>`;

    if (this.isStampCard) {
      return `${giveViaNFC}, and the number of stamps shown above (${
        this.stampsPerScanStampsFormControl?.value ?? 0
      }) will be added.<br>${giveViaApp.replace('points', 'stamps')}`;
    }

    const pointsBasis = this.pointsBasisFormControl?.value?.value;
    const earningMethod = this.pointsEarningMethodFormControl?.value?.value;
    const spendThreshold = this.valueFormControl?.value;
    const pointsPerUnit = this.pointsPerScanFormControl?.value;

    if (pointsBasis === 'transaction') {
      return `${giveViaNFC}, and a fixed number of points (<b>${
        pointsPerUnit ?? 0
      }</b>) will be added.<br>${giveViaApp}`;
    }

    if (pointsBasis === 'value') {
      let message = '';

      if (earningMethod === 'fixed') {
        message = `${giveViaNFC}, to give them <b>${pointsPerUnit}</b> points when they spend <b>£${
          spendThreshold ?? 'x'
        }</b> or more.`;
      } else if (earningMethod === 'incremental') {
        message = `Customers will earn <b>${pointsPerUnit}</b> point(s) for every <b>£${
          spendThreshold ?? 'x'
        }</b> they spend. You’ll need to use the <a href="https://remyrewards.co.uk/mapp" target="_blank">Remy Connect</a> app to award these points.`;
      }

      const methodLine =
        this.isOpenEndedPointsCard &&
        (earningMethod === 'fixed' || pointsBasis === 'transaction')
          ? `<br>${giveViaApp}`
          : this.isStampCard || this.isPointsCard
            ? `<br>${giveViaNFC}.<br>${giveViaApp}`
            : '';

      return `${message}${methodLine}${
        this.isOpenEndedPointsCard ? eposNote : ''
      }`;
    }

    return `${giveViaNFC}, and the number of points shown above (<b>${
      pointsPerUnit ?? 0
    }</b>) will be added.<br>${giveViaApp}`;
  }

  setDynamicPlaceholders() {
    const merchantType = this.authService
      .getNestedUserProperty('merchant', 'type')
      ?.toLowerCase();

    // Define placeholders based on merchant type for loyalty cards
    const placeholders = {
      cafe: {
        title: 'e.g. Free coffee',
        description: 'e.g. Buy 9 coffees, get your 10th free!',
      },
      restaurant: {
        title: 'e.g. Free meal',
        description: 'e.g. Dine with us 9 times, get your 10th meal free!',
      },
      bakery: {
        title: 'e.g. Free pastry',
        description: 'e.g. Buy 9 pastries, get your 10th free!',
      },
      beauty: {
        title: 'e.g. Free treatment',
        description: 'e.g. Book 9 treatments, get your 10th free!',
      },
      barber: {
        title: 'e.g. Free haircut',
        description: 'e.g. Get 9 haircuts, get your 10th free!',
      },
      'pubs & bars': {
        title: 'e.g. Free drink',
        description: 'e.g. Buy 9 drinks, get your 10th free!',
      },
      shops: {
        title: 'e.g. Loyalty discount',
        description:
          'e.g. Shop with us 9 times, get 10% off your 10th purchase!',
      },
      online: {
        title: 'e.g. Free shipping',
        description: 'e.g. Place 9 orders, get free shipping on your 10th!',
      },
    };

    // Set placeholders based on merchant type, fallback to cafe defaults
    const selectedPlaceholders =
      placeholders[merchantType as keyof typeof placeholders] ||
      placeholders.cafe;
    this.titlePlaceholder = selectedPlaceholders.title;
    this.descriptionPlaceholder = selectedPlaceholders.description;
  }

  private maybeInitializeUnsavedChangesTracking(): void {
    if (this.unsavedTrackingReady) {
      return;
    }

    if (this.loading) {
      return;
    }

    this.markUnsavedChangesAsSaved();
    this.unsavedTrackingReady = true;
    this.form.markAsPristine();
  }

  private markUnsavedChangesAsSaved(): void {
    this.savedStateSnapshot = this.buildUnsavedChangesSnapshot();
  }

  private shouldWarnUnsavedChanges(): boolean {
    if (
      this.skipUnsavedChangesWarning ||
      this.saving ||
      !this.unsavedTrackingReady ||
      this.loading
    ) {
      return false;
    }

    return this.savedStateSnapshot !== this.buildUnsavedChangesSnapshot();
  }

  private buildUnsavedChangesSnapshot(): string {
    this.persistCurrentThemeSelection();

    const snapshot = {
      title: this.titleFormControl.value,
      description: this.descriptionFormControl.value,
      terms:
        this.termsEditor?.getSanitizedAndLinkifiedContent() || this.html.trim(),
      locations:
        (this.locationFormControl.value as Location[] | undefined)?.map(
          (location) => location?._id,
        ) ?? [],
      cardType: this.cardTypeFormControl.value?.value,
      numberOfStamps: this.totalStampsFormControl.value,
      joinStamps: this.joinStampsFormControl.value,
      stampsPerScan: this.stampsPerScanStampsFormControl.value,
      points: {
        totalPoints: this.totalPointsFormControl.value,
        joinPoints: this.joinPointsFormControl.value,
        maxPoints: this.maxPointsFormControl.value,
        pointsPerScan: this.pointsPerScanFormControl.value,
        expiry: {
          active: this.pointsExpire,
          days: this.pointsExpiryFormControl.value,
        },
        basis: this.pointsBasisFormControl.value?.value,
        earningMethod: this.pointsEarningMethodFormControl.value?.value,
        value: this.valueFormControl.value,
      },
      displayAs: this.fromFormControl.value,
      colorControls: {
        card: this.cardColorFormControl.value,
        text: this.textColorFormControl.value,
        stampOutline: this.stampColorFormControl.value,
        stampFill: this.stampFillColorFormControl.value,
        stampFillEmpty: this.stampFillEmptyFormControl.value,
        icons: this.iconColorFormControl.value,
        progressBar: this.progressBarFormControl.value,
        progressBarBg: this.progressBarBgFormControl.value,
        gradient: this.cardGradient,
      },
      restrictions: {
        connectOverride: this.connectOverride,
        dailyEnabled: this.stampsPerDay,
        dailyValue: this.stampsPerDayStampsFormControl.value,
        dailyAsset: this.selectedDailyOption,
        intervalEnabled: this.interval,
        intervalHours: this.intervalHoursFormControl.value,
        intervalMinutes: this.intervalMinutesFormControl.value,
        intervalAsset: this.selectedIntervalOption,
      },
      showLogo: this.showLogo,
      shape: this.shape,
      soundOn: this.soundOn,
      opacity: this.opacitySliderValue,
      backgroundOpacity: this.bgImageOpacityValue,
      stampIcon: this.stampIcon,
      rewardIcon: this.rewardIcon,
      postAcquisitionIcon: this.postAcquisitionIcon,
      showCustomLogo: this.showCustomLogo,
      customLogo: this.normalizeFileForSnapshot(this.customLogo),
      stampImage: this.normalizeFileForSnapshot(
        this.stampImage ?? this.card?.stampImage,
      ),
      rewardImage: this.normalizeFileForSnapshot(
        this.rewardImage ?? this.card?.rewardImage,
      ),
      backgroundImage: this.normalizeFileForSnapshot(
        this.backgroundImage ?? this.card?.backgroundImage,
      ),
      rewardIcons: (this.rewardIcons ?? []).map((rewardIcon) => ({
        stamp: rewardIcon?.stamp,
        mobile: rewardIcon?.mobile,
        web: rewardIcon?.web,
        filled: rewardIcon?.filled,
        image: this.normalizeFileForSnapshot(rewardIcon?.image),
      })),
      rewards: (this.rewards ?? []).map((reward) => ({
        stamp: reward?.stamp,
        points: reward?.points,
        rewardId:
          reward?.reward?._id ?? reward?.reward?.toString?.() ?? reward?.reward,
      })),
      earningMethods: this.earningMethods ?? [],
      postAcquisitionPopup: {
        enabled: this.postAcquisitionEnabledFormControl.value,
        title: this.postAcquisitionTitleFormControl.value,
        description: this.postAcquisitionDescriptionFormControl.value,
        actionTitle: this.postAcquisitionActionTitleFormControl.value,
        actionType: this.postAcquisitionActionTypeFormControl.value?.value,
        actionUrl: this.postAcquisitionActionUrlFormControl.value,
      },
      defaultThemeState: this.defaultThemeState,
      variants: this.variantsPayload,
    };

    return JSON.stringify(snapshot);
  }

  private normalizeFileForSnapshot(file: any): any {
    if (!file) {
      return null;
    }

    return {
      url: file.url ?? null,
      key: file.key ?? null,
      name: file.name ?? null,
      hasContent: !!file.content,
    };
  }
}
